export enum E_DISCOUNT_TYPE {
  PERCENT = 'percent',
  FIX = 'fix',
  MONTH = 'month',
}

export const DISCOUNT_TYPE = Object.values(E_DISCOUNT_TYPE);
export type T_DISCOUNT_TYPE = (typeof DISCOUNT_TYPE)[number];
